import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthService } from '../../../api/services/auth.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, RouterModule,
    MatCardModule, MatFormFieldModule, MatInputModule,
    MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatSnackBarModule
  ],
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {
  form: FormGroup;
  loading = false;
  hidePassword = true;
  success = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      lastName:  ['', Validators.required],
      email:     ['', [Validators.required, Validators.email]],
      password:  ['', [Validators.required, Validators.minLength(8)]],
      phone:     ['']
    });
  }

  ngOnInit(): void {
    // A token on THIS route means an old verification email. Verifying now
    // has its own screen — this one is for creating an account — so hand it
    // over rather than showing "your email is verified" on a sign-up page.
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.router.navigate(['/verify-email'], { queryParams: { token } });
    }
  }


  submit(): void {
    if (this.form.invalid) return;
    this.loading = true;

    this.auth.registerCustomer(this.form.value).subscribe({
      next: () => {
        this.loading = false;
        this.success = true;
        this.snackBar.open('Registration successful! Check your email to verify your account.', 'OK', { duration: 6000 });
        // Stay put. This used to jump to /login after 2.5 seconds, which took
        // the person away from the one instruction that matters — check your
        // email — and dropped them on a sign-in page where their new account
        // cannot sign in yet, because it is not verified. The panel below says
        // what to do next and stays on screen until they do it.
      },
      error: (err) => {
        this.loading = false;
        const msg = err.error?.error || err.error?.message || 'Registration failed. Please try again.';
        this.snackBar.open(msg, 'Close', { duration: 5000, panelClass: 'snack-error' });
      }
    });
  }
}
